import { Form, Input, Radio } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import type DocumentWithMembershipStore from 'stores/DocumentWithMembershipStore';
import { DOCUMENT_ROLE_LABELS, DOCUMENT_ROLE_ORDER } from 'types/Roles';

import { ModalForm, type SubmitCallback } from '../../ModalForm';

export interface EditMemberModalProps {
  isVisible?: boolean;
  memberId: string;
  onClose?: () => void;
  parentDocument: DocumentWithMembershipStore;
}

function EditMemberModal({
  isVisible,
  memberId,
  onClose,
  parentDocument,
}: EditMemberModalProps) {
  const user = parentDocument.members.getUserByMemberId(memberId);
  const initialBinding = parentDocument.members.getById(memberId);

  const handleFormSubmit: SubmitCallback = async (values) => {
    await parentDocument.members.updateMember(memberId, values.documentRole);
  };

  return (
    <ModalForm
      formName="EditMemberModalForm"
      okText="Save"
      onClose={onClose}
      onSubmit={handleFormSubmit}
      open={isVisible}
      title="Save"
    >
      <Form.Item label="User Email">
        <Input disabled value={user?.email || ''} />
      </Form.Item>

      <Form.Item
        name="documentRole"
        initialValue={initialBinding?.role}
        rules={[{ required: true }]}
      >
        <Radio.Group>
          {DOCUMENT_ROLE_ORDER.map((role) => (
            <Radio key={role} value={role}>
              {DOCUMENT_ROLE_LABELS[role]}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>
    </ModalForm>
  );
}

export default observer(EditMemberModal);
